import {useEffect, useState} from "react";

/**
 * Liefert eine entprellte Kopie von {@code value}, die sich erst aktualisiert, wenn {@code delayMs}
 * ohne weitere Änderung vergangen ist. Drosselt den Live-Freitextfilter der Startseiten-Suchzeile,
 * sodass höchstens alle ~800 ms Tippen eine Such-/Count-Anfrage abgeht statt bei jedem Tastendruck.
 * @param value der sich schnell ändernde Eingabewert
 * @param delayMs Entprell-Verzögerung in Millisekunden
 * @return der Wert zum Zeitpunkt der letzten Ruhephase
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
    const [debounced, setDebounced] = useState<T>(value);
    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(id);
    }, [value, delayMs]);
    return debounced;
}
